import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { UserInfo } from 'src/app/store/actions/user.action';
import { AppState } from 'src/app/store/app.states';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent {

  constructor(private store: Store<AppState>,public webApi: WebapiService) {
    this.webApi.setLoader(true)
  }

  ngOnInit(): void {
    this.store.dispatch(new UserInfo())
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.webApi.setLoader(false)
    }, 3000);
  }
}
